import React from "react";

// Wiederverwendbarer Kopfbereich für Unterseiten
export default function PageHero({ title, subtitle, image, eyebrow }) {
  return (
    <section className="relative h-[42vh] min-h-[320px] flex items-end overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center scale-105"
        style={{ backgroundImage: `url(${image})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-primary/90 via-primary/50 to-primary/20" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 pb-12 w-full">
        {eyebrow && (
          <span className="inline-block text-accent text-sm font-600 uppercase tracking-[0.25em] mb-3">
            {eyebrow}
          </span>
        )}
        <h1 className="font-serif text-4xl md:text-6xl font-600 text-white leading-none">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-4 text-lg text-white/85 max-w-2xl font-300">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
